import script from "./ArtefactDashboardBid.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtefactDashboardBid.vue?vue&type=script&setup=true&lang=ts"

import "./ArtefactDashboardBid.vue?vue&type=style&index=0&id=35a18bdd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a18bdd"]])

export default __exports__